import BaIcon from '../assets/icons/BaIcon'
import EngIcon from '../assets/icons/EngIcon'

export const LANGUAGE_STORAGE_KEY = 'i18nextLng'

// Labels are in their own language so they never need translating
export const SUPPORTED_LANGUAGES = [
  { code: 'bos', label: 'Bosanski', Icon: BaIcon },
  { code: 'en', label: 'English', Icon: EngIcon },
]

// 'bos' is the frontend code, 'bs' is the BCP-47 code browsers expect
export const toHtmlLang = (lng) => (lng === 'bos' ? 'bs' : lng)

// Backend translations live in locales/ba
export const toBackendLang = (lng) => (lng === 'bos' ? 'ba' : lng)

// Prefer the language the UI actually shows; i18n.language can be unset before init
// or differ from it when a translation file fails to load
export const getBackendLanguage = (i18n) => toBackendLang(i18n.resolvedLanguage || i18n.language || 'bos')
